import { Component, computed, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { WrapperComponent } from '../../../../../wrapper/wrapper.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { MatDialog } from '@angular/material/dialog';
import { InternalApprovalComponent } from '@/app/components/global/internal-approval/internal-approval.component';
import { UserService } from '@/app/services/user.service';
import { ApprovalResponseComponent } from '@/app/components/global/approval-response/approval-response.component';
import { InivitationToTenderViewComponent } from '../../inivitation-to-tender-view/inivitation-to-tender-view.component';
import { NgToastService } from 'ng-angular-popup';
import { IttApplicantReadOnlyFormComponent } from '@/app/components/projects/shared/tendering/ITT/itt-applicant-read-only-form/itt-applicant-read-only-form.component';
import { ActionConfirmationDialogueComponent } from '@/app/components/global/Dialogues/action-confirmation-dialogue/action-confirmation-dialogue.component';
import { WarningMessages } from '@/app/enums/warning-messages.enum';
import { CustomTooltipComponent } from '../../../../../../global/custom-tooltip/custom-tooltip.component';
import { ToolTipMessages } from '@/app/enums/toolTipMessages.enum';
import { BriefSectionComponent } from '../../../project-expression-of-interest/brief-section/brief-section.component';
import { RfpLabelService } from '../../rfp-labels.service';
import { ScoreService } from '../../scores.service';

interface Organization {
  id: number;
  external_company_name: string | null;
  name: string;
  email: string;
  position: string;
  applicant_organization: {
    id: number;
    name: string;
    email: string;
  } | null;
  responseId: number;
  responseStatus: string;
  rfp_response: null | any;
  technicalEvaluationScore: number | string;
  commercialEvaluationScore: number | string;
  contractAwarded: boolean;
}

interface workPackges {
  id: number;
  name: string;
}

interface submittedData {
  submission_deadline: string;
  submission_address: string;
  contract_type_details: string;
  contract_type_attach: string;
  issue_date: string;
  clarification_deadline: string;
  contract_start_date: string;
  contract_award_notification: string;
  project_completion_date: string;
  awarded_org_id: number | null;
  is_initiated: boolean | number | null;
}

@Component({
  selector: 'app-itt-organization-detail-form',
  standalone: true,
  imports: [
    MatChipsModule,
    MatButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    WrapperComponent,
    MatExpansionModule,
    IttApplicantReadOnlyFormComponent,
    CustomTooltipComponent,
    BriefSectionComponent,
  ],
  templateUrl: './itt-organization-detail-form.component.html',
  styleUrl: './itt-organization-detail-form.component.css',
})
export class IttOrganizationDetailFormComponent implements OnInit {
  isEdit = false;
  currentDialog = 'itt-wrapper';
  projectName: string;
  projectId: number | string;
  ittId: number | string;
  isCreator: boolean = false;
  orgInfo: any;
  sendApprovals = false;
  usersList: any;
  internalApproval: any;
  approvalResponses: any;
  approvalNote: any;
  isInApprovers: boolean = false;
  checkApprove: boolean = false;
  is_initiated: boolean = false;
  selectedOrgs: Organization[] = [];
  selectedWp: workPackges[] = [];
  submittedData: submittedData;
  isLoadingInitiate = false;
  tenderType: string = 'construction works';
  showTooltip: boolean = false;
  approvalsStatus: string = 'pending';
  toolTipMessage = ToolTipMessages;
  projectIdentifier: string;
  showTemplateForm: boolean = false;

  labels: any = {};  // Object to store loaded labels
  isRFP: boolean = false;
  isRFQ: boolean = false;
  isRFPorRFQ: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private TenderingService: TenderingService,
    private dialog: MatDialog,
    private userService: UserService,
    private toast: NgToastService,
    private rfpLabelService: RfpLabelService,
    private scoreService: ScoreService
  ) {}

  roles = [
    'Admin',
    'Project Manager',
    'Site Supervisor',
    'Civil Engineer',
    'Quantity Surveyor',
    'Architect',
    'Safety Officer',
    'Construction Manager',
    'Procurement Officer',
    'Foreman',
  ];

  toggle() {
    this.showTemplateForm = !this.showTemplateForm;
  }

  ngOnInit(): void {
    // Subscribe to route changes
    this.route.url.subscribe(() => {
      this.updateRFPorRFQFlag();
      const currentRoute = this.router.url; // Get full URL path
      this.rfpLabelService.updateLabelsFromRoute(currentRoute);
    });
    this.rfpLabelService.labels$.subscribe((labels) => {
      this.labels = labels;
    });

    this.projectId = this.route.snapshot.paramMap.get('projectId')!;
    this.ittId = this.route.snapshot.paramMap.get('ittId')!;
    this.route.queryParams.subscribe((params) => {
      this.projectName = params['projectName'];
      this.projectIdentifier = params['projectIdentifier'];
    });
    this.getITTSubmittedInitiationData();
    const orgInfoString = localStorage.getItem('org_info');
    if (orgInfoString) {
      this.orgInfo = JSON.parse(orgInfoString); // Converts the string to an object
    }
    this.getIttApprovalsStatus();
    this.fetchUsers();
  }

  updateRFPorRFQFlag() {
    const currentRoute = this.router.url.toLowerCase(); // Get full URL path
    if(currentRoute.includes('rfp')){
      this.isRFPorRFQ = 'RFP';
    }else if(currentRoute.includes('rfq')){
      this.isRFPorRFQ = 'RFQ'
    }
    console.log('isRFPorRFQ:', this.isRFPorRFQ);
  }

  getITTSubmittedInitiationData() {
    // Only developer side data without on which step we are
    return this.TenderingService.SubmittedInitiationData(
      this.projectId,
      this.ittId
    ).subscribe({
      next: (response: any) => {
        if (response) {
          const applicantOrganizations = response?.data?.selected_organizations;
          this.selectedWp = response?.data?.selected_work_packages.map(
            (wp) => ({
              ...wp,
            })
          );
          this.submittedData = response?.data;
          console.log('response?.data', this.submittedData);

          this.tenderType = response?.data?.tendering_type;
          console.log(this.tenderType);

          this.enrichOrganizations(applicantOrganizations);

          console.log('applicantOrganizations', applicantOrganizations);

          if(this.isRFPorRFQ === 'RFP'){
            const initialScores: Record<number, { tech: number, comm: number }> = this.selectedOrgs.reduce((acc, org) => {
              const orgId = org?.applicant_organization?.id;
              if (orgId) {
                acc[orgId] = {
                  tech: typeof org.technicalEvaluationScore === 'number' ? org.technicalEvaluationScore : parseFloat(org.technicalEvaluationScore) || 0, // Default to 0 if undefined
                  comm: typeof org.commercialEvaluationScore === 'number' ? org.commercialEvaluationScore : parseFloat(org.commercialEvaluationScore) || 0, // Default to 0 if undefined
                };
              }
              return acc;
            }, {} as Record<number, { tech: number, comm: number }>);
            
            this.scoreService.setInitialScores(initialScores);
          }

          // const initiator_id = response?.data?.initiator_id;
          const created_by = response?.data?.created_by;

          if (created_by === this.orgInfo?.pivot?.user_id) {
            this.isCreator = true;
          } else {
            this.isCreator = false;
          }
          this.is_initiated = response?.data?.is_initiated;
        }
      },
      error: (error) => {
        console.error('Error fetching data:', error);
      },
    });
  }

  // Get both scores dynamically
  getScoresForRow(rowId: number) {
    return computed(() => this.scoreService.getScores(rowId));
  }

  enrichOrganizations(applicantOrganizations): void {
    this.selectedOrgs = applicantOrganizations.map((org) => ({
      ...org,
      responseId: org?.rfp_response?.id || {},
    }));

    this.selectedOrgs.forEach((org) => {
      org.contractAwarded =
        org?.applicant_organization?.id == this.submittedData.awarded_org_id
          ? true
          : false;
      org.responseStatus = org.rfp_response.status;
      org.technicalEvaluationScore =
        JSON.parse(org.rfp_response.technical_evaluation)?.Score ?? '--';
      org.commercialEvaluationScore =
        JSON.parse(org.rfp_response.commercial_evaluation)?.Score ?? '--';
    });
  }

  formatDate(input: string | null | undefined): string {
    // Split the input into date and time parts
    const [date, time] = input.split('T');
    const [hours, minutes] = time.split(':').map(Number);

    // Convert to 12-hour format and determine AM/PM
    const period = hours >= 12 ? 'PM' : 'AM';
    const formattedHour = hours % 12 || 12; // Convert 0 or 24 to 12 in 12-hour format

    // Return the formatted string
    return `${date} ${formattedHour}:${minutes
      .toString()
      .padStart(2, '0')} ${period}`;
  }

  handleApprovals() {
    this.sendApprovals = true;
    const dialogRef = this.dialog.open(InternalApprovalComponent, {
      width: '80vw',
      height: 'auto',
      maxWidth: 'unset',
      autoFocus: false,
      data: {
        ResponseId: this.ittId,
        projectId: this.projectId,
        users: this.usersList,
        approvalResponses: this.approvalResponses,
        modalType: 'itt',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'closeApproval') {
        this.getIttApprovalsStatus();
        this.sendApprovals = false;
      }
    });
  }

  async getIttApprovalsStatus(): Promise<void> {
    try {
      const response = await this.TenderingService.ittInternalApprovals(
        this.projectId,
        'itt',
        this.ittId
      ).toPromise();

      if (response?.data) {
        this.internalApproval = response?.data;
        this.approvalNote = response?.data?.internal_approvals?.notes;
        this.approvalsStatus = response?.data?.internal_approvals?.status
          ? response?.data?.internal_approvals?.status
          : 'pending';
        let responses =
          response?.data?.internal_approvals?.internal_approval_responses;

        if (responses) {
          responses = responses.map((user: any) => ({
            id: user.user_id,
            role: this.roles[Math.floor(Math.random() * this.roles.length)],
            status: user?.status,
            comment: user?.comment,
            name: user?.name,
            email: user?.user?.email,
          }));
        }

        const userId = +this.orgInfo?.pivot?.user_id;

        const inApprovers =
          response?.data?.internal_approvals?.internal_approval_responses.find(
            (response: any) => response?.user_id === userId
          );

        if (inApprovers) {
          this.isInApprovers = true;
        } else {
          this.isInApprovers = false;
        }

        this.approvalResponses = responses;

        if (responses && this.orgInfo?.pivot?.user_id) {
          const matchingResponse = responses.find(
            (response: any) =>
              response?.id === userId && response?.status !== 'pending'
          );
          this.checkApprove = !!matchingResponse;

          if (this.checkApprove) {
            this.approvalResponses = null;
            this.approvalResponses = matchingResponse;
          }
        } else {
          this.checkApprove = false;
        }
      }
    } catch (error) {
      console.error('Error approvals status:', error);
    }
  }

  handleAwardContractModal(applicantOrg) {
    const AwardConfirmationDialogRef = this.dialog.open(
      ActionConfirmationDialogueComponent,
      {
        width: '60vw',
        autoFocus: false,
        disableClose: true, // Prevent closing on outside click
        data: {
          title: 'Request for Proposal Confirmation',
          label:
            'Are you sure you want to Award Contract to this Organization!',
          confirmText: 'Yes',
          cancelText: 'No',
        },
      }
    );

    AwardConfirmationDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const tempProjectId =
          typeof this.projectId === 'string'
            ? Number(this.projectId)
            : this.projectId;
        const tempRfpId =
          typeof this.ittId === 'string' ? Number(this.ittId) : this.ittId;
        this.TenderingService.rfpAwardContractToApplicantOrganization(
          tempProjectId,
          tempRfpId,
          applicantOrg?.responseId
        ).subscribe({
          next: (response: any) => {
            if (response?.meta?.success) {
              console.log(response);
              applicantOrg.contractAwarded = response?.data === true;
            }
          },
          error: (error: any) => {
            this.toast.danger(error?.error?.data, 'DANGER', 4000);
          },
        });
      }
    });
  }

  approvalResponseView(ResponseId: any, projectId: any) {
    this.sendApprovals = true;
    const dialogRef = this.dialog.open(ApprovalResponseComponent, {
      width: '70vw',
      maxHeight: '80vh',
      maxWidth: 'unset',
      autoFocus: false,
      disableClose: true, // Prevent closing on outside click
      data: {
        ResponseId: ResponseId,
        projectId: projectId,
        note: this.approvalNote,
        approvalSender: this.approvalResponses,
        modalType: 'itt',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'closeApproval') {
        this.sendApprovals = false;
        this.getIttApprovalsStatus();
      }
    });
  }

  sendInvite() {
    // Show the loading spinner (scroller) when initiating the action
    this.isLoadingInitiate = true;
    this.TenderingService.initiateITT(this.projectId, this.ittId).subscribe({
      next: () => {
        // Hide the loading spinner after a successful operation
        this.isLoadingInitiate = false;
        this.toast.success('RFP Initiated', 'SUCCESS');
        this.handleClose();
      },
      error: (error: any) => {
        // Hide the loading spinner on error
        this.isLoadingInitiate = false;
        this.toast.danger(error?.error?.data, 'DANGER', 4000);
      },
    });
  }

  fetchUsers() {
    this.userService.getUsers().subscribe(
      (response: any) => {
        if (response) {
          this.usersList = response.map((user: any) => ({
            id: user.id,
            name: user.name,
            email: user.email,
            role: this.roles[Math.floor(Math.random() * this.roles.length)],
          }));
        } else {
          console.error("Response does not contain 'data' property.");
        }
      },
      (error) => {
        console.log('Failed to load users: ', error);
      }
    );
  }

  handleClarification() {
    if (this.is_initiated) {
      this.router.navigate([
        `/projects/${this.projectId}/rfp/${this.ittId}/clarifications`,
      ]);
    } else {
      this.toast.warning(WarningMessages.RFP_NOT_INITIATED_WARNING, 'WARNING');
    }
  }

  handleDialog() {
    this.isEdit = false;
    this.getITTSubmittedInitiationData();
  }
  handleClose() {
    if(this.isRFPorRFQ === 'RFP'){
      this.router.navigate([`${this.projectId}/tendering/rfp`], {
        queryParams: {
          projectName: this.projectName,
          projectIdentifier: this.projectIdentifier,
        },
      });
    }else if(this.isRFPorRFQ === 'RFQ'){
      this.router.navigate([`${this.projectId}/tendering/rfq`], {
        queryParams: {
          projectName: this.projectName,
          projectIdentifier: this.projectIdentifier,
        },
      });
    }
  }
  async openIttView(responseId, rfp_response, applicantOrgId) {
    const isRfpResponseSubmitted = await this.fetchRfpStatus(responseId);
    if (isRfpResponseSubmitted) {
      this.dialog.open(InivitationToTenderViewComponent, {
        width: '78vw',
        height: '80vh',
        maxWidth: 'unset',
        autoFocus: false,
        data: {
          applicantOrgId: applicantOrgId,
          projectId: this.projectId,
          ittId: this.ittId,
          responseId: responseId ? responseId : 11,
          tendererResponse: rfp_response,
          selectedWp: this.selectedWp,
          tenderType: this.tenderType,
        },
      });
    } else {
      this.toast.warning(
        WarningMessages.COMPANY_RESPONSE_MISSING_WARNING,
        'WARNING'
      );
    }
  }
  fetchRfpStatus(eoiResponseId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.TenderingService.checkRfpResponseStatus(
        +this.projectId,
        +this.ittId,
        eoiResponseId
      ).subscribe({
        next: (response: any) => {
          if (response.meta.success) {
            resolve(response?.data);
          } else {
            reject('Failed to fetch response');
          }
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }

  tooltipVisibilityToggle() {
    this.showTooltip = !this.showTooltip;
  }

  handleEdit() {
    this.isEdit = !this.isEdit;
    this.TenderingService.setEditState(this.isEdit);
    this.TenderingService.setProjectIdentifier(this.projectIdentifier);
  }
}
